/**
 * Gebietswahl auf dem Client.
 *
 * Das gewählte Gebiet liegt clientseitig und ist später der Schalter für eine
 * gebietsgefilterte Startseite. Gespeichert wird, was die Daten sagen — der
 * Stadtteil trägt seinen Bezirk selbst (`bezirkSlug`); nichts wird aus Namen
 * abgeleitet.
 *
 * Zwei Schlüssel, mit Absicht:
 * - `GEBIET_SELECTION_KEY` — das genaue Gebiet (Bezirk ODER Stadtteil), neu.
 * - `BEZIRK_SELECTION_KEY` — der Bezirk allein (`bezirke.ts`), den Profil und
 *   Veedel-Seite schon kennen. Wird mitgeschrieben, damit beide Wege dasselbe
 *   sehen. Eingeloggte pflegen den Bezirk zusätzlich im UserProfile; das
 *   Zusammenführen beider Quellen ist ein offenes Thema.
 */

import { BEZIRK_SELECTION_KEY } from "./bezirke.js";

export const GEBIET_SELECTION_KEY = "app.gebiet.selection";

/** Auf welcher Ebene das gewählte Gebiet liegt — keine Ableitung, es steht in den Daten. */
export type GebietsAuswahlEbene = "stadtbezirk" | "stadtteil";

export interface GebietsAuswahl {
  ebene: GebietsAuswahlEbene;
  slug: string;
  name: string;
  /** Amtliche Nummer — steht so in Gremiennamen und Gebietsschlüsseln. */
  nr: string;
  /** Bezirk des Gebiets; bei einem Stadtbezirk er selbst. */
  bezirkSlug: string;
}

export function leseGebietsAuswahl(): GebietsAuswahl | undefined {
  const roh = localStorage.getItem(GEBIET_SELECTION_KEY);
  if (!roh) return undefined;
  try {
    const wert = JSON.parse(roh) as Partial<GebietsAuswahl>;
    if (!wert?.slug || !wert.name || !wert.bezirkSlug || !wert.ebene) return undefined;
    return wert as GebietsAuswahl;
  } catch {
    // Kaputter Eintrag (Formatwechsel, manuelle Änderung): still verwerfen.
    return undefined;
  }
}

export function speichereGebietsAuswahl(auswahl: GebietsAuswahl): void {
  localStorage.setItem(GEBIET_SELECTION_KEY, JSON.stringify(auswahl));
  localStorage.setItem(BEZIRK_SELECTION_KEY, auswahl.bezirkSlug);
}

export function loescheGebietsAuswahl(): void {
  localStorage.removeItem(GEBIET_SELECTION_KEY);
}
